import React, { useState, useEffect, useRef } from "react";
import {
  Grid, TextField, Box, Button, Tooltip, Typography, Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Paper, Tabs, Tab, Card, CardContent, Divider, Chip, IconButton, Dialog, DialogTitle, DialogContent,
} from "@mui/material";
import {
  Search as SearchIcon,
  Add as AddIcon,
  Dashboard as DashboardIcon,
  TrackChanges as TrackIcon,
  ArrowForward as ArrowForwardIcon,
  Visibility as VisibilityIcon,
} from "@mui/icons-material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import axiosInstance from "../../lib/axios";
import { format } from "date-fns";
import ImageIcon from '@mui/icons-material/Image';
import Modal from '@mui/material/Modal';
import HistoryIcon from '@mui/icons-material/History';
import CloseIcon from '@mui/icons-material/Close';
import dayjs from "dayjs";

const TicketStatus = () => {
  const [formData, setFormData] = useState({
    ticketNo: "",
    ToDo: "",
    Remark: "",
  });

  const [error, setError] = useState({
    ticketNo: false,
    ToDo: "",
    Remark: ""
  });

  const [activeStep, setActiveStep] = useState(0);
  const [showHistoryTable, setShowHistoryTable] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [dashboardStats, setDashboardStats] = useState({
    openTickets: 0,
    inProgressTickets: 0,
    resolvedTickets: 0,
    tickets: []
  });

  const navigate = useNavigate();
  const [ticketHistory, setTicketHistory] = useState([]);
  const residentId = localStorage.getItem("ResidentId");
  const [UserId, setUserId] = useState(localStorage.getItem('UserId'));
  const formatDate = (dateString) => format(new Date(dateString), "dd/MM/yyyy");
  const formatTime = (timeString) => format(new Date(timeString), "HH:mm:ss");
  const ticketNoRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [followHistory, setFollowHistory] = useState([]);
  const [followUpDialogOpen, setFollowUpDialogOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);

  const openDialog = () => {
    setOpen(true);
  };

  const dialogClose = () => {
    setOpen(false);
  };

  const handleFollowUpClick = () => {
    setFollowUpDialogOpen(true);
  };

  const handleFollowUpCancel = () => {
    setFollowUpDialogOpen(false);
    setFormData({
      Todo: '',
      Remark: ''
    })
  };

  useEffect(() => {
    if (activeTab === 0) {
      fetchDashboardStats();
    }
  }, [activeTab]);

  const fetchDashboardStats = async () => {
    try {
      const payload = {
        ResidentId: residentId,
        Flag: 'ByResidentId',
        TicketNo: ''
      }
      const response = await axiosInstance.post("TrnTicketing/GetResidentTickets", payload);
      const data = response.data.Data || [];
      const openTickets = data.filter(t => t.TicketSt === 'O').length;
      const inProgressTickets = data.filter(t => t.TicketSt === 'I' || t.TicketSt === 'P').length;
      const resolvedTickets = data.filter(t => t.TicketSt === 'R').length;
      setDashboardStats({
        openTickets,
        inProgressTickets,
        resolvedTickets,
        tickets: data
      });
    } catch (err) {
      toast.error("Failed to fetch ticekt status:", err);
    }
  };

  const handleSubmitFollowup = async () => {
    if (!selectedTicket) {
      toast.error("No ticket selected");
      return;
    }

    try {
      const currentDate = dayjs().format('YYYY-MM-DD');
      const response = await axiosInstance.post('TrnTktFlw/InsertTrnTktFlw', {
        FlwDt: currentDate,
        TicketId: selectedTicket.TicketId,
        ToDo: formData.ToDo,
        Remark: formData.Remark,
        FlwUserId: 1,
        FlwResidentId: selectedTicket.ResidentId,
        CreatedBy: 1,
        TktFlwImage: "",
        ImgName: ""
      });

      if (response.data.status === 0 && response.data.ResponseStatusCode === 1) {
        toast.success(response.data.Message || 'Follow-up added successfully.');

        setFormData({ ToDo: "", Remark: "" });
        setFollowUpDialogOpen(false);
        setSelectedTicket(null);
        fetchDashboardStats();
      }
    } catch (error) {
      toast.error("Error while adding follow-up");
    }
    setFollowUpDialogOpen(false);
  };

  const fetchFollowHistory = async (ticketId) => {
    try {
      const response = await axiosInstance.post('TrnTktFlw/RetriveTrnTktFlw', {
        Flag: "Tkt",
        FlwId: 1,
        TicketId: ticketId,
      });

      if (response.data?.Status === 0) {
        setFollowHistory(response.data.Data);
      } else {
        setFollowHistory([]);
      }
    } catch (err) {
      toast.error("Failed to fetch follow-up history");
      setFollowHistory([]);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setError((prevState) => ({
      ...prevState,
      [name]: false,
    }));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleSearch = async () => {
    if (!formData.ticketNo) {
      setError({ ticketNo: true });
      return;
    }

    try {
      const response = await axiosInstance.post("TrnTicketing/GetResidentTickets", {
        ResidentId: residentId,
        Flag: 'ByResidentId',
        TicketNo: formData.ticketNo,
      });

      const { data: { Status, Message, Data } } = response;

      if (Status === 0 && Message && Data?.length > 0) {
        setTicketHistory(Data);
        setShowHistoryTable(true);
        updateActiveStep(Data[0].TicketSt);
      } else {
        setTicketHistory([]);
        setShowHistoryTable(false);
        toast.info("Ticket not found.");
      }
    } catch (err) {
      toast.error(err || "Error while fetching the tickets.");
    }
  };

  const updateActiveStep = (status) => {
    switch (status) {
      case "O":
        setActiveStep(0);
        break;
      case "I":
      case "P":
        setActiveStep(1);
        break;
      case "R":
      case "C":
        setActiveStep(2);
        break;
      default:
        setActiveStep(0);
    }
  };

  const handleViewDetails = (ticketId) => {
    navigate(`/ticket-details/${ticketId}`);
  };

  const steps = ["Open", "Inprogress", "Resolved"];

  const toggleHistoryTable = () => {
    setShowHistoryTable((prevState) => !prevState);
  };

  const getStatusText = (TicketSt) => {
    switch (TicketSt) {
      case "R":
        return "Resolved";
      case "O":
        return "Open";
      case "C":
        return "Closed";
      case "I":
      case "P":
        return "In Progress";
      case "H":
        return "Hold";
      default:
        return "Unknown";
    }
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleImageClick = (url) => {
    setSelectedImage(url);
    setImageModalOpen(true);
  };

  const handleImageModalClose = () => {
    setImageModalOpen(false);
    setSelectedImage(null);
  };

  return (
    <Box sx={{
      backgroundColor: "#f5f7fa",
      minHeight: "100vh",
      padding: { xs: 2, md: 4 }
    }}>
      <ToastContainer />

      <Box sx={{
        maxWidth: "950px",
        margin: "0 auto",
        backgroundColor: "#fff",
        borderRadius: "12px",
        boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
        overflow: "hidden"
      }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', alignItems: 'center', px: 1 }}>
          <IconButton
            onClick={() => navigate("/resident-profile")}
            sx={{ mr: 1, p: 0 }}
          >
            <ArrowBackIcon />
          </IconButton>

          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            sx={{
              flex: 1,
              minHeight: 48,
              '& .MuiTabs-indicator': {
                height: 3,
                backgroundColor: '#1976d2',
              },
            }}
          >
            <Tab
              label={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <DashboardIcon sx={{ fontSize: 20, mr: 1 }} />
                  Dashboard
                </Box>
              }
              sx={{
                textTransform: 'none',
                fontSize: '0.875rem',
                fontWeight: 600,
              }}
            />
            <Tab
              label={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <TrackIcon sx={{ fontSize: 20, mr: 1 }} />
                  Track Ticket
                </Box>
              }
              sx={{
                textTransform: 'none',
                fontSize: '0.875rem',
                fontWeight: 600,
              }}
            />
          </Tabs>
        </Box>

        {/* Tab Content */}
        <Box sx={{ padding: 2 }}>
          {activeTab === 0 ? (
            <>
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={4}>
                  <Card sx={{
                    borderLeft: '4px solid #ff5252',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                    transition: 'transform 0.2s',
                    '&:hover': {
                      transform: 'translateY(-2px)'
                    }
                  }}>
                    <CardContent sx={{ py: 1.2, px: 2 }}>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        Open Tickets
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography variant="h4" sx={{ fontWeight: 700, color: "#ff5252" }}>
                          {dashboardStats.openTickets}
                        </Typography>
                        <Box sx={{
                          width: 40,
                          height: 40,
                          borderRadius: '50%',
                          backgroundColor: 'rgba(255, 82, 82, 0.1)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <Typography variant="body2" sx={{ color: "#ff5252", fontWeight: 700 }}>
                            {Math.round((dashboardStats.openTickets / (dashboardStats.openTickets + dashboardStats.inProgressTickets + dashboardStats.resolvedTickets) || 0) * 100)}%
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* In Progress Tickets Card */}
                <Grid item xs={12} md={4}>
                  <Card sx={{
                    borderLeft: '4px solid #2196f3',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                    transition: 'transform 0.2s',
                    '&:hover': {
                      transform: 'translateY(-2px)'
                    }
                  }}>
                    <CardContent sx={{ py: 1, px: 2 }}>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        In Progress
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography variant="h4" sx={{ fontWeight: 700, color: "#2196f3" }}>
                          {dashboardStats.inProgressTickets}
                        </Typography>
                        <Box sx={{
                          width: 40,
                          height: 40,
                          borderRadius: '50%',
                          backgroundColor: 'rgba(33, 150, 243, 0.1)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <Typography variant="body2" sx={{ color: "#2196f3", fontWeight: 700 }}>
                            {Math.round((dashboardStats.inProgressTickets / (dashboardStats.openTickets + dashboardStats.inProgressTickets + dashboardStats.resolvedTickets) || 0) * 100)}%
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Card sx={{
                    borderLeft: '4px solid #4caf50',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                    transition: 'transform 0.2s',
                    '&:hover': {
                      transform: 'translateY(-2px)'
                    }
                  }}>
                    <CardContent sx={{ py: 1.2, px: 2 }}>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        Resolved Tickets
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography variant="h4" sx={{ fontWeight: 700, color: "#4caf50" }}>
                          {dashboardStats.resolvedTickets}
                        </Typography>
                        <Box sx={{
                          width: 40,
                          height: 40,
                          borderRadius: '50%',
                          backgroundColor: 'rgba(76, 175, 80, 0.1)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <Typography variant="body2" sx={{ color: "#4caf50", fontWeight: 700 }}>
                            {Math.round((dashboardStats.resolvedTickets / (dashboardStats.openTickets + dashboardStats.inProgressTickets + dashboardStats.resolvedTickets) || 0) * 100)}%
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>

              <Divider sx={{ my: 2 }} />

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  mb: 1.5
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    color: "#333",
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <ArrowForwardIcon color="primary" sx={{ mr: 1, fontSize: 20 }} />
                  Recent Tickets
                </Typography>

                <Button variant="outlined" size="small"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    color: '#635bff',
                    textTransform: 'none',
                    borderRadius: '20px'
                  }}
                  onClick={() => setActiveTab(1)}
                >
                  <AddIcon sx={{ mr: 0.5 }} />
                  Create
                </Button>
              </Box>

              <Box sx={{ paddingTop: '10px' }}>
                <Grid container spacing={1}>
                  {dashboardStats.tickets.length > 0 ? (
                    dashboardStats.tickets.map((ticket, index) => (
                      <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card
                          variant="outlined"
                          sx={{
                            borderRadius: 2,
                            boxShadow: 1,
                            px: 1.5,
                            py: 1,
                            backgroundColor: '#f0f8ff',
                            transition: '0.2s',
                            '&:hover': {
                              boxShadow: 3,
                            },
                          }}
                        >
                          {/* Ticket No and Status */}
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              mb: 0.5,
                            }}
                          >
                            <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>
                              Ticket No: {ticket.TicketNo}
                            </Typography>
                            <Tooltip title='Add Follow up' arrow>
                              <IconButton
                                sx={{ p: 0 }}
                                onClick={() => {
                                  setSelectedTicket(ticket);
                                  setFollowUpDialogOpen(true);
                                }}
                              >
                                <AddIcon sx={{ fontSize: '20px' }} />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title='Follow up history' arrow>
                              <IconButton sx={{ p: 0 }}
                                onClick={() => {
                                  fetchFollowHistory(ticket.TicketId);
                                  openDialog();
                                }}
                              >
                                <HistoryIcon sx={{ fontSize: '20px' }} />
                              </IconButton>
                            </Tooltip>

                            <Chip
                              label={getStatusText(ticket.TicketSt)}
                              size="small"
                              sx={{
                                fontWeight: 500,
                                height: 20,
                                fontSize: '11px',
                                backgroundColor:
                                  ticket.TicketSt === 'O'
                                    ? '#ffccd5'
                                    : ticket.TicketSt === 'I' || ticket.TicketSt === 'P'
                                      ? '#90caf9'
                                      : ticket.TicketSt === 'R'
                                        ? '#a5d6a7' : ticket.TicketSt === 'H' ? '#d6d4f7'
                                          : '#eeeeee',
                                color:
                                  ticket.TicketSt === 'O'
                                    ? '#7f0000'
                                    : ticket.TicketSt === 'I' || ticket.TicketSt === 'P'
                                      ? '#0d3c61'
                                      : ticket.TicketSt === 'R'
                                        ? '#1b4d18' : ticket.TicketSt === 'H' ? '#635bff'
                                          : '#333333',
                              }}
                            />
                          </Box>

                          <Typography sx={{ fontSize: '13px', mb: 0.3 }}>
                            Date: {formatDate(ticket.TktDate)} at {formatTime(ticket.TktDate)}
                          </Typography>

                          <Typography sx={{ fontSize: '13px', mb: 0.3 }}>
                            Category: {ticket.CategoryName}
                          </Typography>

                          <Typography sx={{ fontSize: '13px', mb: 0.3 }}>
                            Ticket For: {ticket.ServiceName}
                          </Typography>

                          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                            <Typography sx={{ fontSize: '13px' }}>
                              Tag: {ticket.TicketTagName}
                            </Typography>
                            <Typography sx={{ fontSize: '13px' }}>
                              Priority: {ticket.TicketServName}
                            </Typography>
                          </Box>

                          <Typography sx={{ fontSize: '13px' }}>
                            Remark: {ticket.Remark}
                          </Typography>

                          {ticket.ImageUrl && (
                            <IconButton
                              onClick={() => handleImageClick(ticket.ImageUrl)}
                              sx={{ position: 'absolute', top: 8, right: 8 }}
                              title="View Attached Image"
                            >
                              <ImageIcon sx={{ color: '#555' }} />
                            </IconButton>
                          )}
                        </Card>
                      </Grid>
                    ))
                  ) : (
                    <Grid item xs={12}>
                      <Card
                        sx={{
                          padding: 2,
                          borderRadius: 2,
                          textAlign: 'center',
                          boxShadow: 1,
                        }}
                        variant="outlined"
                      >
                        <Typography variant="body2" color="text.secondary">
                          No tickets found
                        </Typography>
                      </Card>
                    </Grid>
                  )}
                </Grid>
              </Box>
            </>
          ) : (
            <>
              {/* Track Ticket Tab - Your existing content */}
              <Typography variant="h5"
                sx={{
                  fontWeight: "bold",
                  color: "#333",
                  marginTop: "0px",
                  marginBottom: 0,
                  marginLeft: 0,
                }}
              >
                Track Ticket
              </Typography>

              <Grid item xs={12} className="form_field"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mt: 2,
                }}
              >
                <Grid container spacing={2} maxWidth={600} justifyContent="center">
                  <Grid item xs={12} md={12}>
                    <TextField
                      className="custom-textfield"
                      id="ticketNo"
                      name="ticketNo"
                      label="Ticket No"
                      variant="filled"
                      fullWidth
                      value={formData.ticketNo}
                      onChange={handleInputChange}
                      onKeyDown={handleKeyPress}
                      error={error.ticketNo}
                      helperText={error.ticketNo && "Ticket No. is required"}
                      inputRef={ticketNoRef}
                    />
                  </Grid>
                  <Grid item xs={12} md={12} sx={{ display: "flex", alignItems: "center" }}>
                    <Button
                      variant="contained"
                      onClick={handleSearch}
                      fullWidth
                      sx={{ height: "100%" }}
                    >
                      <SearchIcon />
                      Search
                    </Button>
                  </Grid>
                </Grid>
              </Grid>

              {/* Stepper */}
              <Grid item xs={12} md={12}
                sx={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Stepper activeStep={activeStep} alternativeLabel sx={{ flex: 4 }}>
                  {steps.map((label, index) => {
                    const stepColor =
                      activeStep === index
                        ? index === 0
                          ? "red"
                          : index === 1
                            ? "#2196f3"
                            : "#4caf50"
                        : "#dcdcdc";

                    return (
                      <Step key={label}>
                        <StepLabel
                          sx={{
                            color: stepColor,
                            fontWeight: "bold",
                            "& .MuiStepIcon-root": {
                              color: stepColor,
                            },
                            "& .MuiStepLabel-active .MuiStepIcon-root": {
                              color: stepColor,
                            },
                            "& .MuiStepLabel-completed .MuiStepIcon-root": {
                              color: stepColor,
                            },
                          }}
                        >
                          {label}
                        </StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>

                <Tooltip title="Click to show/hide the ticket history" arrow>
                  <Button
                    variant="outlined"
                    onClick={toggleHistoryTable}
                    sx={{
                      width: 32,
                      height: 32,
                      borderRadius: '50%',
                      padding: 0,
                      minWidth: 0,
                      minHeight: 0,
                      lineHeight: 1,
                    }}
                  >
                    <AddIcon sx={{ fontSize: 20 }} />
                  </Button>
                </Tooltip>
              </Grid>

              {showHistoryTable && (
                <Box sx={{ width: '100%', mt: 3 }}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 'bold',
                      color: '#333',
                      mb: 2,
                      textAlign: 'left',
                    }}
                  >
                    Ticket History
                  </Typography>

                  <Grid container spacing={1}>
                    {ticketHistory.length === 0 ? (
                      <Grid item xs={12}>
                        <Typography variant="body2" color="text.secondary">
                          No ticket history found.
                        </Typography>
                      </Grid>
                    ) : (
                      ticketHistory.map((history, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                          <Card
                            variant="outlined"
                            sx={{
                              borderRadius: 2,
                              boxShadow: 1,
                              px: 1.5,
                              py: 1,
                              backgroundColor: '#f0f8ff',
                              transition: '0.2s',
                              '&:hover': {
                                boxShadow: 3,
                                backgroundColor: '#f0f0f0',
                              },
                            }}
                          >
                            {/* Ticket No + Status */}
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                mb: 0.5,
                              }}
                            >
                              <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>
                                Ticket No: {history.TicketNo}
                              </Typography>

                              <Chip
                                label={getStatusText(history.TicketSt)}
                                size="small"
                                sx={{
                                  fontWeight: 500,
                                  height: 20,
                                  fontSize: '11px',
                                  backgroundColor:
                                    history.TicketSt === 'O'
                                      ? '#ffccd5'
                                      : history.TicketSt === 'I' || history.TicketSt === 'P'
                                        ? '#90caf9'
                                        : history.TicketSt === 'R'
                                          ? '#a5d6a7'
                                          : '#eeeeee',
                                  color:
                                    history.TicketSt === 'O'
                                      ? '#7f0000'
                                      : history.TicketSt === 'I' || history.TicketSt === 'P'
                                        ? '#0d3c61'
                                        : history.TicketSt === 'R'
                                          ? '#1b4d18'
                                          : '#333333',
                                }}
                              />
                            </Box>

                            {/* Date and Time in the same line */}
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                              <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>
                                <span style={{ color: '#111' }}>Date:</span> {formatDate(history.TktDate)}
                              </Typography>
                              <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>
                                <span style={{ color: '#111' }}>Time:</span> {formatTime(history.TktTime)}
                              </Typography>
                            </Box>
                            <Typography sx={{ fontSize: '13px' }}>
                              <span style={{ color: '#111' }}>SubCategory: </span>{history.SubCategoryName}
                            </Typography>
                            <Typography sx={{ fontSize: '13px' }}>
                              <span style={{ color: '#111' }}>ServiceProvider: </span>{history.ServiceProvider}
                            </Typography>
                            <Typography sx={{ fontSize: '13px' }}>
                              <span style={{ color: '#030000ff' }}>Ticket For:</span> {history.ServiceName}
                            </Typography>
                          </Card>
                        </Grid>
                      ))
                    )}
                  </Grid>
                </Box>
              )}
            </>
          )}
        </Box>
      </Box>
      <Modal
        open={imageModalOpen}
        onClose={handleImageModalClose}
        aria-labelledby="ticket-image-modal"
        aria-describedby="ticket-image-preview"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'white',
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
            maxWidth: '90vw',
            maxHeight: '90vh',
          }}
        >
          {selectedImage ? (
            <img
              src={selectedImage}
              alt="Ticket Attachment"
              style={{ maxWidth: '100%', maxHeight: '80vh', borderRadius: '8px' }}
            />
          ) : (
            <Typography>No image available</Typography>
          )}
        </Box>
      </Modal>

      {/* Insert Follow Up history */}
      <Dialog open={followUpDialogOpen} onClose={handleFollowUpCancel} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ py: 1, px: 3, display: 'flex', alignItems: 'center' }}>
          <AddIcon sx={{ mr: 1 }} color='secondary' />
          <Typography variant="h6" color='secondary'>Follow Up</Typography>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} mt={1}>
            <Grid item xs={12} md={12} lg={12}>
              <TextField
                id='ToDo'
                name="ToDo"
                fullWidth
                multiline
                rows={1}
                variant='filled'
                label="Todo"
                className="custom-textfield"
                value={formData.ToDo}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <TextField
                id="Remark"
                name="Remark"
                fullWidth
                multiline
                rows={1}
                variant='filled'
                label="Remark"
                className="custom-textfield"
                value={formData.Remark}
                onChange={handleInputChange}
              />
            </Grid>

            <Grid item xs={12} lg={12} mt={1} display="flex" justifyContent="flex-end">
              <Button size='small'
                variant="contained"
                onClick={handleSubmitFollowup}
                sx={{ marginRight: 1 }}
              >
                Submit
              </Button>
              <Button size='small'
                variant="outlined"
                color='error'
                onClick={handleFollowUpCancel}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      {/* Retrieve Follow up history */}
      <Dialog open={open} onClose={dialogClose} maxWidth="md" fullWidth>
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
            <Typography variant="h5" fontWeight="bold" color='secondary'>
              Follow Up History
            </Typography>
            <IconButton onClick={dialogClose} sx={{ borderRadius: '50%' }}>
              <CloseIcon color="error" />
            </IconButton>
          </Box>

          {followHistory.length === 0 ? (
            <Typography color="text.secondary" sx={{ py: 4, textAlign: 'center', fontSize: '1.1rem' }}>
              No follow-up entries found for this ticket. Please do the follow up and check again.!
            </Typography>
          ) : (
            <TableContainer component={Paper} elevation={2}
              sx={{
                maxHeight: '40vh',
                borderRadius: 2,
              }}
            >
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    {['Ticket No', 'FollowBy', 'ToDo', 'Remark', 'Date'].map((head) => (
                      <TableCell
                        key={head}
                        sx={{
                          fontWeight: 600,
                          backgroundColor: 'grey.100',
                          borderBottom: '2px solid',
                          borderColor: 'divider',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {head}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {followHistory.map((entry, idx) => (
                    <TableRow key={idx} hover
                      sx={{
                        backgroundColor: idx % 2 === 0 ? 'background.paper' : 'grey.50',
                        '& td': {
                          verticalAlign: 'top',
                          py: 1,
                        },
                      }}
                    >
                      <TableCell sx={{ fontWeight: 500 }}>
                        <Chip size='small'
                          label={entry.TicketNo || 'N/A'}
                          sx={{
                            fontSize: '0.75rem',
                            bgcolor: '#e3f2fd',
                            color: '#0288d1',
                            border: '1px solid #81d4fa',
                            fontWeight: 600,
                            height: 20,
                            paddingY: '2px',
                            '& .MuiChip-label': {
                              px: 1,
                            },
                          }}
                        />
                      </TableCell>
                      <TableCell>{entry.FlwUser ? entry.FlwUser : entry.ResidentName || '-'}</TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                          <Tooltip title={entry.ToDo} arrow>
                            {entry.ToDo && entry.ToDo.length > 20 ? `${entry.ToDo.substring(0, 20)}...` : entry.ToDo || '-'}
                          </Tooltip>
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            width: '100%',
                          }}
                        >
                          <Tooltip title={entry.Remark} arrow>
                            {entry.Remark && entry.Remark.length > 20 ? `${entry.Remark.substring(0, 20)}...` : entry.Remark || '-'}
                          </Tooltip>
                        </Typography>
                      </TableCell>

                      <TableCell sx={{ whiteSpace: 'nowrap' }}>
                        <Typography variant="caption">
                          {entry.FlwDt ? new Date(entry.FlwDt).toLocaleString('en-IN', {
                            dateStyle: 'medium',
                            timeStyle: 'short',
                          })
                            : '-'}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      </Dialog>
    </Box>
  );
};

export default TicketStatus;